const Overview = ({small, large, domain, label, onClick}) => (
    <div className="region-image overview-map">
        <a className={domain} href={large} onClick={onClick}>
            <img src={small} alt={label} />
        </a>
    </div>
);

export default Overview;
